import React from 'react'
import Img from 'src/components/shared/Img'

const DebtReliefCard = ({ heroPerson = {} }) => {
  return (
    <div className={`relative mx-auto mt-10 max-w-md p-6 text-center`}>
      {/* Circular Image */}
      <div className="shadow-lg size-[360px] relative mx-auto ml-10 overflow-hidden rounded-full border-4 border-white">
        <Img
          src="/next-assets/image.webp"
          alt="Client"
          layout="fill"
          imgClassName="object-cover"
          priority
        />
      </div>

      {/* Floating Labels */}
      <div
        className={`text-black shadow left-50 ml-15 absolute top-10 mt-[50px] -translate-x-1/3 rounded-full bg-orange-250 px-4 py-1 md:mt-[90px] lg:left-0 lg:py-2`}
      >
        {heroPerson?.totalDebt
          ? heroPerson?.totalDebt
          : 'Resolved $17,183 in debt'}
      </div>
      <div
        className={`bg-green-500 shadow absolute top-28 right-20 mt-[50px] translate-x-1/3 rounded-full bg-green-120 px-4 py-1 text-white md:mt-[70px] lg:right-0 lg:py-2`}
      >
        {heroPerson?.debtsResolved
          ? heroPerson?.debtsResolved
          : 'Settled 4 enrolled debts!'}
      </div>
      <div className="shadow left-35 absolute bottom-44 mt-10 ml-[70px] -translate-x-1/3 rounded-full bg-blue-500 px-4 py-1 text-white lg:bottom-52 lg:left-0 lg:py-2">
        {heroPerson?.montlyPayment
          ? heroPerson?.montlyPayment
          : '1 monthly payment of $362'}
      </div>
      <div className="shadow absolute right-12 bottom-25 mr-5 translate-x-1/3 rounded-full bg-blue-700 px-4 py-1 text-white md:mr-0 lg:py-2">
        {heroPerson?.name ? heroPerson?.name : 'Patti B., Albany, NY'}
      </div>

      {/* Footer Text */}
      <p className="mt-10 ml-12 text-sm text-gray-500">
        {heroPerson?.description
          ? heroPerson?.description
          : 'Actual client of Freedom Debt Relief.'}
        <br />
        {heroPerson?.conclusion
          ? heroPerson?.conclusion
          : 'Individual results are not typical and will vary.'}
      </p>
    </div>
  )
}

export default DebtReliefCard
